import Button from '@/common/components/base/button/Button';
import DateInput from '@/common/components/base/input/dateInput/DateInput';
import TextInputWithSelectOnMap from '@/common/components/base/input/mapInput/TextInputWithSelectOnMap';
import TimeInput from '@/common/components/base/input/timeInput/TimeInput';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { GetTimeSetQueryResponseType } from '@/common/queries/getTimeSet/getTimeSetQuery.type';
import { getTimeSetQueryOptions } from '@/common/queries/getTimeSet/getTimeSetQueryOptions';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { validateNotPastDate } from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
type props = {
  open: boolean;
  closeModal: () => void;
  onSubmitForm: (data: SetTimeFormType) => void;
};
export type SetTimeFormType = {
  adjuster_visit_date: string;
  adjuster_visit_time: string;
  visit_location: string;
  visit_location_phi?: number | null;
  visit_location_lambda?: number | null;
};
const TimeSetModal: React.FC<props> = (props) => {
  const { open, closeModal } = props;
  const { id } = useParams();

  const methods = useForm<SetTimeFormType>({ mode: 'onSubmit' });
  const onSubmit = (data: SetTimeFormType) => {
    props.onSubmitForm(data);
    closeModal();
  };

  useQuery({
    ...getTimeSetQueryOptions({ id: +id! }),
    meta: {
      onSuccess: (data: GetTimeSetQueryResponseType) =>
        methods.reset({
          adjuster_visit_date: data?.adjuster_visit_date
            ? convertTimestampToShamsi(data?.adjuster_visit_date)
            : '',
          adjuster_visit_time: data?.adjuster_visit_time || '',
          visit_location: data?.visit_location || data?.visit_location,
          visit_location_lambda: data?.location_lambda || null,
          visit_location_phi: data?.location_phi || null,
        }),
    },
  });

  return (
    <MainModal open={open} closeModal={closeModal}>
      <FormProvider {...methods}>
        <TitleDescription>
          <Typography textStyle="h2">
            اطلاعات مربوط به بازدید را تکمیل نمایید.
          </Typography>
        </TitleDescription>

        <Box mt={48} display="flex" flexDirection="column">
          <DateInput
            label="تاریخ بازدید"
            buttonText="ثبت"
            modalLabel="تاریخ بازدید"
            name="adjuster_visit_date"
            rules={{
              required: 'وارد کردن تاریخ بازدید اجباری است',
              validate: validateNotPastDate,
            }}
            minDate={new Date(Date.now() - 24 * 60 * 60 * 1000)}
          />
          <TimeInput
            label="ساعت بازدید"
            buttonText="ثبت ساعت بازدید"
            modalLabel="ساعت بازدید"
            name="adjuster_visit_time"
            rules={{ required: 'وارد کردن ساعت بازدید اجباری است' }}
          />
          <TextInputWithSelectOnMap
            rules={{ required: 'وارد کردن آدرس بازدید اجباری است' }}
            label="آدرس بازدید"
            entranceModalText={
              'در ادامه  آدرس بازدید  را بر روی نقشه مشخص کنید .'
            }
            mapModalTitle="آدرس بازدید"
            name="visit_location"
            phiName="visit_location_phi"
            lambdaName="visit_location_lambda"
          />
          <Button
            fullWidth
            disabled={!methods?.formState?.isValid}
            onClick={methods.handleSubmit(onSubmit)}
          >
            ثبت
          </Button>
        </Box>
      </FormProvider>
    </MainModal>
  );
};
export default TimeSetModal;
